import { useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "elite_sidebar_collapsed";
const MOBILE_BREAKPOINT = 1024;

function getViewportWidth() {
  if (typeof window === "undefined") {
    return MOBILE_BREAKPOINT + 1;
  }

  return window.innerWidth;
}

export default function useSidebarState() {
  const [isMobile, setIsMobile] = useState(getViewportWidth() <= MOBILE_BREAKPOINT);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }

    return window.localStorage.getItem(STORAGE_KEY) === "true";
  });
  const [isMobileOpen, setIsMobileOpen] = useState(
    getViewportWidth() > MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    function handleResize() {
      const mobile = getViewportWidth() <= MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      setIsMobileOpen((current) => (mobile ? current : true));
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, String(isCollapsed));
    }
  }, [isCollapsed]);

  const sidebarWidth = useMemo(() => {
    if (isMobile) {
      return isMobileOpen ? 264 : 0;
    }

    return isCollapsed ? 88 : 264;
  }, [isCollapsed, isMobile, isMobileOpen]);

  return {
    isMobile,
    isCollapsed,
    isMobileOpen,
    sidebarWidth,
    toggle() {
      if (isMobile) {
        setIsMobileOpen((current) => !current);
        return;
      }

      setIsCollapsed((current) => !current);
    },
    closeMobile() {
      if (isMobile) {
        setIsMobileOpen(false);
      }
    },
  };
}
